import React from 'react';
import { useDragDrop } from '../../hooks/useDragDrop';
import useArticlesSlider from '../../hooks/useArticlesSlider';
import {
  Button,
  Table,
  OverlayTrigger,
} from "react-bootstrap";
import {
  DragHandleOutlined,
  VisibilityOutlined,
  DeleteForeverOutlined,
} from "@mui/icons-material";
import Tooltip from "react-bootstrap/Tooltip";
import SidebarSlides from './SidebarSlides';

function DragAndDropSliders({sliders, handleVisibilityArticle, handleDelete}) {
  const { setArticles, updateArticlesPositions} = useArticlesSlider();
  const { dragStart, dragEnter, drop } = useDragDrop({
    list: sliders,
    setList: setArticles,
  });
  const handleSaveSlidersPositions = (e) => {
    e.preventDefault();
    updateArticlesPositions();
  }
  return (
    <>
      <Table responsive className="basePgi__table-list" hover>
        <colgroup>
          <col span="1" className="basePgi__table-col-min" />
          <col span="1" className="basePgi__table-col-position" />
          <col span="1" className="basePgi__table-col-max" />
          <col span="3" className="basePgi__table-col-min" />
        </colgroup>
        <tbody>
          {sliders?.map(
            (slider, index) =>
              (
                <tr
                  key={slider._id}
                  onDragStart={() => dragStart(index)}
                  onDragEnter={() => dragEnter(index)}
                  onDragEnd={() => drop("article")}
                  onDragOver={(e) => e.preventDefault()}
                  draggable
                  className="draggable"
                >
                  <td>
                    {" "}
                    <Button disabled>
                      <DragHandleOutlined />
                    </Button>
                  </td>
                  <td className="pgi__table-position-number">
                    <b>{index + 1}</b>
                  </td>
                  <td>{slider.title}</td>
                  <td onClick={() => handleVisibilityArticle(slider._id, slider)}>
                    <OverlayTrigger
                      key="1"
                      placement="top"
                      overlay={<Tooltip id="1">Visibilidad</Tooltip>}
                    >
                      <Button className={slider.state ? "" : "disabled"}>
                        {" "}
                        <VisibilityOutlined />{" "}
                      </Button>
                    </OverlayTrigger>
                  </td>
                  <td>
                    <SidebarSlides isEdit={true} sliderToEdit={slider} />
                  </td>
                  <td onClick={() => handleDelete(slider._id)}>
                    <OverlayTrigger
                      key="1"
                      placement="top"
                      overlay={<Tooltip id="1">Eliminar</Tooltip>}
                    >
                      <Button>
                        <DeleteForeverOutlined />
                      </Button>
                    </OverlayTrigger>
                  </td>
                </tr>
              )
          )}
        </tbody>
      </Table>
      <div className='d-flex justify-content-center'>
        <button 
          className="settings_button-pleno"
          onClick={handleSaveSlidersPositions}
        >
          Guardar Posiciones
        </button>
      </div>
    </>
  )
}

export default DragAndDropSliders;
